@if (layerToDelete) {
  <p-confirmDialog
    key="dataLayerDeleteDialog"
    #cd
    styleClass="w-9"
    appendTo="body"
    [blockScroll]="false">
    <ng-template pTemplate="headless" let-message>
      <div class="p-card border-round pt-1 p-4">
        <app-header
          icon="fas fa-trash"
          [text]="layerToDelete.year + ' wirklich löschen?'"></app-header>

        @if (layerHasData) {
          <p appAlertStyle="warning" class="p-3">
            <i class="fas fa-exclamation-triangle"></i>
            Dabei werden auch alle Daten, die mit dem Jahr verknüpft sind,
            unwiderruflich gelöscht!
          </p>
          <p-divider></p-divider>
          <app-header
            icon="fas fa-database"
            text="Enthaltene Daten"
            [count]="
              indicatorDataStore.countByDataLayer(layerToDelete._id)
            "></app-header>
          <p-scrollPanel styleClass="h-20rem">
            <app-data-layer-data-list [dataLayer]="layerToDelete" />
          </p-scrollPanel>
        } @else {
          <app-alert [canToggle]="false" styleClass="p-3">
            <i class="fas fa-circle-info"></i> Diesem Jahr sind keine Daten
            zugeordnet. Es kann sicher gelöscht werden.
          </app-alert>
        }

        <p-divider></p-divider>
        <div class="flex align-items-center gap-3 mt-4">
          <button
            [rounded]="true"
            [outlined]="true"
            severity="secondary"
            pButton
            icon="fas fa-times"
            label="nein, abbrechen"
            (click)="cd.reject()"></button>
          <button
            [rounded]="true"
            pButton
            [severity]="'danger'"
            icon="fas fa-check"
            label="ja, löschen"
            (click)="cd.accept()"
            class="ml-auto"></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
